// Company Information
export const companyInfo = {
  name: "Liquid Stretch",
  tagline: "Experience Life Pain Free",
  description: "Advanced wireless pain relief technology that helps you live life to the fullest.",
  contact: {
    email: "help@liquidstretch.com",
    phone: "(800) 123-4567",
    address: {
      street: "123 Innovation Drive",
      city: "San Francisco",
      state: "CA",
      zip: "94105"
    },
    hours: {
      weekday: "Monday - Friday: 9am - 5pm PST",
      saturday: "Saturday: Closed",
      sunday: "Sunday: Closed"
    }
  }
};

// Navigation
export const navigation = {
  main: [
    { name: "Products", href: "/products" },
    { name: "About", href: "/about" },
    { name: "Contact", href: "/contact" },
    { name: "Is This Legal?", href: "/legal" }
  ]
};

// Hero Sections
export const heroContent = {
  home: {
    title: "Experience Life Pain Free",
    description: "Advanced wireless TENS + EMS technology for instant, targeted pain relief.",
    image: "/images/pl hero.webp",
    cta: "Shop Now"
  },
  about: {
    title: "Our Mission",
    description: "Making advanced pain relief technology accessible to everyone.",
    image: "https://images.unsplash.com/photo-1487700160041-babef9c3cb55"
  },
  contact: {
    title: "Contact Us",
    description: "We're here to help you on your journey to pain-free living.",
    image: "https://images.unsplash.com/photo-1496449903678-68ddcb189a24"
  }
};

// Product
export const mainProduct = {
  name: "Liquid Stretch Pro",
  shortDescription: "Revolutionary wireless TENS + EMS device",
  fullDescription: "The Liquid Stretch Pro is a state-of-the-art wireless TENS + EMS device that provides instant pain relief. With 14 therapy modes, 25 intensity levels, and up to 10 hours of battery life, it's designed to give you maximum control over your pain management.",
  features: [
    "14 Therapy Modes",
    "25 Intensity Levels",
    "10-Hour Battery Life",
    "Wireless Design",
    "FDA Cleared",
    "1-Year Warranty"
  ],
  price: "299.99",
  image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30"
};

// Benefits Section
export const benefits = [
  {
    title: "Drug-Free Pain Relief",
    description: "Natural pain management without medication side effects."
  },
  {
    title: "Clinically Proven",
    description: "FDA-cleared technology backed by scientific research."
  },
  {
    title: "100% Satisfaction",
    description: "Try Liquid Stretch Pro risk-free with our money-back guarantee."
  }
];

// Company Values
export const values = [
  {
    title: "Innovation",
    description: "Continuously advancing pain relief technology."
  },
  {
    title: "Quality",
    description: "Premium materials and rigorous testing standards."
  },
  {
    title: "Customer Care",
    description: "Dedicated support throughout your wellness journey."
  }
];